import { React, useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    Modal,
    Box,
    Typography
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { startOfMonth, endOfMonth } from 'date-fns';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../Page';
import { handleError } from '../../Common/Utils';

// ----------------------------------------------------------------------
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflow: 'auto',
    borderRadius: '8px',
};


// ----------------------------------------------------------------------

export default function IRQuestionnairesListing() {
    const { enqueueSnackbar } = useSnackbar();

    const TABLE_HEAD = [
        { field: 'ProductName', headerName: 'Product Name', flex: 1 },
        { field: 'ClientName', headerName: 'Client Name', flex: 1 },
        { field: 'Status', headerName: 'Status', flex: 1 },

         {
            field: 'actions',
            headerName: '',
            type: 'actions',
             flex: 1 ,
            renderCell: (cellValues) => {
                return (<div>

                    <IconButton
                        onClick={(event) => {
                            handleEdit(event, cellValues);
                        }}><Iconify icon="ic:outline-edit" width='20px' height='20px' color='primary.main' /></IconButton>

                </div>
                );
            }
         },

    ];
    const navigate = useNavigate();
    // dropdown
    const [selectedProductsId, setSelectedProductsId] = useState('');
    const [products, setProducts] = useState([]);

    const [client, setClient] = useState('');
    const [selectedClient, setSelectedClient] = useState([]);

    const [copyProducts, setCopyProducts] = useState('');
    const [selectedCopyProducts, setSelectedCopyProducts] = useState([]);

    const [copyClient, setCopyClient] = useState('');
    const [selectedCopyClient, setSelectedCopyClient] = useState([]);

    const [openModal, setOpenModal] = useState(false);
    const [pageSize, setPageSize] = useState(25);

    const handleProducts = (id) => {
        setSelectedProductsId(id);

    };
    const handleClients = (id) => {
        setClient(id);

    };
    const handleCopyProducts = (id) => {
        setCopyProducts(id);
    };
    const handleCopyClients = (id) => {
        setCopyClient(id);

    };
    const handleEdit = (event, cellValues) => {
        console.log("edit", cellValues, cellValues.row.InstallationReportQuestionnairesMasterId)
        URLS.loadQuestionList({ InstallationReportQuestionnairesMasterId: cellValues.row.InstallationReportQuestionnairesMasterId })
            .then((response) => {
                const jsonDataString = JSON.stringify(response.data);

                const modifiedData = JSON.parse(jsonDataString);
                console.log("modifiedData", modifiedData)
                setCopyQuestionariesData(modifiedData);
                setIsLoading(false);
                navigate('/dashboard/irquestionnairesdetailscomponent', { state: { copyQuestionariesData: modifiedData, rowData: cellValues.row } });

            })
            .catch(error => {
                // On error
                setCopyQuestionariesData([]);
                setIsLoading(false);

            });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };
    useEffect(() => {
        URLS.getProductList()
            .then((response) => {
                setProducts(response.data);
                setSelectedCopyProducts(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getCientList()
            .then((response) => {
                setSelectedClient(response.data);
                setSelectedCopyClient(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }, []);

    const [irListingData, setIRListingData] = useState([]);
    const [copyQuestionariesData, setCopyQuestionariesData] = useState([]);

    const [isLoading, setIsLoading] = useState();

    const onFilterClick = () => {
        setIsLoading(true);
        const payload = {
            "ProductId": selectedProductsId,
            "ClientId": client
        };
        URLS.filterQuestionariesData(payload)
            .then((response) => {
                setIRListingData(response.data);
                setIsLoading(false);
                enqueueSnackbar("Fetched Data Successfully. ", { variant: 'success' });

            })
            .catch(error => {
                // On error
                setIRListingData([]);
                setIsLoading(false);
                enqueueSnackbar("Data not found", { variant: 'success' });


            });
    };

    const copyQuestions = () => {
        setOpenModal(true);
    }
    const populatedQuestions = () => {
        const payload = {
            "ProductId": copyProducts,
            "ClientId": copyClient
        };
        URLS.copyQuestionariesLoad(payload)
            .then((response) => {
                console.log("res>>>>>>>", response, response.data)
                if (!response.data || response.data.Message === "No Data found") {
                    enqueueSnackbar("No data found.", { variant: "error" });
                    setIsLoading(false);
                    return;
                }

                const jsonDataString = JSON.stringify(response.data);

                const modifiedData = JSON.parse(jsonDataString);
                console.log("modifiedData", modifiedData)
                setCopyQuestionariesData(modifiedData);
                setIsLoading(false);
                navigate('/dashboard/irquestionnairesdetailscomponent', { state: { copyQuestionariesData: modifiedData } });

            })
            .catch(error => {
                // On error
                setCopyQuestionariesData([]);
                setIsLoading(false);
              
            });

    }
    const handleReset = () => {
        setSelectedProductsId('');
        setClient("");
        setIRListingData([]);

    }

    return (

        <Page title="IR Questionnaires Listing" >

            <Card >
                <Stack direction="row" alignItems="center" justifyContent="space-between" m={1} spacing={1}>
                    <Stack direction="row" spacing={2} alignItems="center">
                    <FormControl
                        size="small" sx={{ minWidth: 230, fontSize: '0.5rem' }}>
                        <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Products</InputLabel>
                        <Select
                            label="Prducts"
                            size="small"
                            value={selectedProductsId}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: '#fbe9e7', // Set the background color here
                                        maxHeight: '200px',
                                        width: '200px',// Set the max height here
                                    }
                                }
                            }}
                        >
                            <MenuItem key={0} value={""} >Select</MenuItem>

                            {products.map((product) => (
                                <MenuItem key={product.Id} value={product.Id} onClick={() => handleProducts(product.Id)}> {product.Name}</MenuItem>
                            ))}
                        </Select>

                    </FormControl>
                    <FormControl
                        size="small" sx={{ minWidth: 230, fontSize: '0.5rem' }}>
                        <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Clients</InputLabel>
                        <Select
                            label="Clients"
                            size="small"
                            value={client}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: '#fbe9e7', // Set the background color here
                                        maxHeight: '200px',
                                        width: '200px',// Set the max height here
                                    }
                                }
                            }}
                        >
                            <MenuItem key={0} value={""} >Select</MenuItem>

                            {selectedClient.map((client) => (
                                <MenuItem key={client.ContactId} value={client.ContactId} onClick={() => handleClients(client.ContactId)}> {client.Name}</MenuItem>
                            ))}
                        </Select>

                    </FormControl>
                    </Stack>

                    <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between" spacing={1}>

                        <Tooltip title="Filter">

                            <Button
                                variant="contained"
                                size="small"
                                onClick={onFilterClick}

                            ><Icon icon="ic:outline-filter-alt" width="25px" height="25px" /></Button>
                        </Tooltip >
                        <Tooltip title="Copy Questionaries">

                            <Button
                                variant="contained"
                                size="small"
                                onClick={copyQuestions}

                            ><Icon icon="ic:outline-content-copy" width="25px" height="25px" /></Button>
                        </Tooltip >
                        <Modal open={openModal} onClose={handleCloseModal}>
                            <Box sx={style}>
                                <IconButton
                                    onClick={handleCloseModal}
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '10px',
                                        color: 'grey',
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h5" color="#E7000B" m={1} >
                                    Populated Questionaries
                                </Typography>
                               
                                <Stack spacing={1}>
                                    <Stack direction="row" spacing={2} alignItems="center">
                                        
                                        <FormControl size="small" fullWidth>
                                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>Products</InputLabel>
                                            <Select
                                                label="Prducts"
                                                size="small"
                                                value={copyProducts}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: '#fbe9e7', // Set the background color here
                                                            maxHeight: '200px',
                                                            width: '200px',// Set the max height here
                                                        }
                                                    }
                                                }}
                                            >
                                                <MenuItem key={0} value={""}>Select</MenuItem>
                                                {selectedCopyProducts.map((product) => (
                                                    <MenuItem key={product.Id} value={product.Id} onClick={() => handleCopyProducts(product.Id)}>{product.Name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl size="small" fullWidth>
                                            <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}>Clients</InputLabel>
                                            <Select
                                                label="Clients"
                                                size="small"
                                                value={copyClient}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: '#fbe9e7', // Set the background color here
                                                            maxHeight: '200px',
                                                            width: '200px',// Set the max height here
                                                        }
                                                    }
                                                }}
                                            >
                                                <MenuItem key={0} value={""}>Select</MenuItem>
                                                {selectedCopyClient.map((client) => (
                                                    <MenuItem key={client.ContactId} value={client.ContactId} onClick={() => handleCopyClients(client.ContactId)}>{client.Name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <Tooltip title="Populated Questionaries">

                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={populatedQuestions}

                                            ><Icon icon="ic:baseline-view-list" width="25px" height="25px" /></Button>
                                        </Tooltip >
                                    </Stack>
                                   
                                </Stack>
                            </Box>
                        </Modal>
                        <Tooltip title="Add New ">

                            <Button
                                component={RouterLink}
                                to='/dashboard/irquestionnairesdetailscomponent'
                                variant="contained"
                                size="small"
                                state={{ irQuestionnaries: { Id: '', ProductId: '', FromDate: '', ToDate: '',IsActive:true } }}
                            ><Icon icon="ic:baseline-plus" width="25px" height="25px" /></Button>

                        </Tooltip >

                        <Tooltip title="Reset">

                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleReset}
                            ><Icon icon="ic:twotone-restart-alt" width="25px" height="25px" /></Button>

                        </Tooltip >

                    </Stack>
                </Stack>
                <Divider />

                {/* ----------------------------------------------------------------- */}

                <div style={{ height: '72vh', width: '100%' }}>
                    <DataGrid rows={irListingData} density={'compact'} columns={TABLE_HEAD} getRowId={(row) => irListingData.indexOf(row)} components={{
                        Toolbar: GridToolbar,
                    }} rowsPerPageOptions={[25, 50, 100]}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}/>
                </div>

            </Card>
            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}


        </Page>


    );
}